import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface KnifeAndForkProps extends IconWrapperProps {
  fill?: string;
}

const KnifeAndFork = ({ fill, ...rest }: KnifeAndForkProps) => (
  <IconWrapper viewBox="0 0 24 24" width="24" height="24" {...rest}>
    <path
      fill={fill || 'currentColor'}
      fillRule="evenodd"
      d="M20 6a4.008 4.008 0 0 0-3-3.874V13h3V6Zm2 0v8a1 1 0 0 1-1 1h-4v8a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1c3.309 0 6 2.691 6 6ZM12 1v9a1 1 0 0 1-1 1H8v12a1 1 0 1 1-2 0V11H3a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v8h2V1a1 1 0 1 1 2 0v8h2V1a1 1 0 1 1 2 0Z"
      clipRule="evenodd"
    />
  </IconWrapper>
);

export default KnifeAndFork;
